// extracted by mini-css-extract-plugin
export default {"container":"App_container__Rt8T2","image":"App_image__sGTHO"};